module.exports = __webpack_public_path__ + "img/Progress-Report-3.de6e126c.png";